"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./SystemDetailTile.scss");
var _AlertTileComponent = require("@ccw-pwa-ui/AlertTileComponent");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SystemDetailTile = function SystemDetailTile(_ref) {
  var _item$waterDest;
  var index = _ref.index,
    alert = _ref.alert,
    item = _ref.item,
    type = _ref.type,
    onclick = _ref.onclick,
    tileImage = _ref.tileImage,
    tileHeading = _ref.tileHeading,
    tileSubHeading = _ref.tileSubHeading,
    waterDestinationItem = _ref.waterDestinationItem,
    everythingOkText = _ref.everythingOkText,
    _ref$isDisable = _ref.isDisable,
    isDisable = _ref$isDisable === void 0 ? true : _ref$isDisable,
    storeSubscriptionText = _ref.storeSubscriptionText,
    rightArrowBtn = _ref.rightArrowBtn,
    statusIcon = _ref.statusIcon,
    statusText = _ref.statusText,
    alertList = _ref.alertList,
    dscIcon = _ref.dscIcon,
    blueDotIcon = _ref.blueDotIcon,
    arrowRightColorIcon = _ref.arrowRightColorIcon,
    expireBlueDotIcon = _ref.expireBlueDotIcon,
    partialLogo = _ref.partialLogo,
    isPartial = _ref.isPartial,
    deleteLogo = _ref.deleteLogo,
    onPartialClick = _ref.onPartialClick,
    onPartialDelete = _ref.onPartialDelete,
    incompleteSystemText = _ref.incompleteSystemText;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "system-tile-wrapper",
    key: index
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "system-tile-header",
    "data-testid": "system-tile-header",
    onClick: function onClick() {
      return onclick(item, type);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "system-tile-proddesc"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "system-tile-left-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "system-tile-left"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "system-tile-left-img"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "system-tile-image",
    src: tileImage,
    alt: ""
  }), " ")), /*#__PURE__*/_react.default.createElement("div", {
    className: "heading-style"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "st-part-name"
  }, /*#__PURE__*/_react.default.createElement("p", null, tileHeading)), /*#__PURE__*/_react.default.createElement("div", {
    className: "st-part-number"
  }, /*#__PURE__*/_react.default.createElement("p", null, tileSubHeading)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "system-tile-right"
  }, type === "system" ? /*#__PURE__*/_react.default.createElement("div", {
    className: "st-icon-div"
  }, item === null || item === void 0 ? void 0 : (_item$waterDest = item.waterDest) === null || _item$waterDest === void 0 ? void 0 : _item$waterDest.map(function (item, i) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: i,
      className: "st-first-icon"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "st-icon-heading"
    }, /*#__PURE__*/_react.default.createElement("p", null, item.name)), /*#__PURE__*/_react.default.createElement("img", {
      src: waterDestinationItem[item.name],
      alt: ""
    }));
  })) : type === "gateway" ? /*#__PURE__*/_react.default.createElement("div", {
    className: "online-wrapper"
  }, isDisable ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("img", {
    className: "online-greenDot",
    src: statusIcon,
    alt: ""
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "online-text"
  }, statusText)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("img", {
    className: "online-greenDot",
    src: blueDotIcon,
    alt: ""
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "suspended-text"
  }, "Suspended"))) : "")), rightArrowBtn && /*#__PURE__*/_react.default.createElement("button", {
    className: "st-btn"
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("img", {
    src: arrowRightColorIcon,
    alt: ">"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "system-tile-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "st-status-heading"
  }, /*#__PURE__*/_react.default.createElement("p", null, "Status")), !isPartial && isDisable ? /*#__PURE__*/_react.default.createElement("div", {
    className: "partialTile"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tileBottom",
    "data-testid": "partialSaveClick",
    onClick: onPartialClick
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: partialLogo,
    alt: ""
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "tileBottomText"
  }, incompleteSystemText)), /*#__PURE__*/_react.default.createElement("div", {
    onClick: onPartialDelete,
    "data-testid": "deleteLogoTest"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: deleteLogo,
    alt: ""
  }))) : null, isPartial && !(alertList !== null && alertList !== void 0 && alertList.length) && isDisable && /*#__PURE__*/_react.default.createElement("div", {
    className: "everythingok-div"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "everthingok-icon"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: dscIcon,
    alt: ""
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(isDisable ? "everthingok-text" : "enableDisable")
  }, everythingOkText)), isDisable ? "" : /*#__PURE__*/_react.default.createElement("div", {
    className: "everythingOkIcon-div",
    "data-testid": "everythingok-div"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: expireBlueDotIcon,
    alt: ""
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "enableDisable",
    "data-testid": "everythingOK"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "enableDisable"
  }, everythingOkText)))), /*#__PURE__*/_react.default.createElement("div", null, (alertList === null || alertList === void 0 ? void 0 : alertList.length) > 0 && isDisable && isPartial && alertList.map(function (tile, i) {
    return /*#__PURE__*/_react.default.createElement(_AlertTileComponent.AlertTileComponent, {
      key: i,
      variant: "tile",
      isRead: tile.isRead,
      noBoarder: true,
      fullWidth: true,
      wrapperStyle: tile.wrapperStyle,
      optionBtnTitle: tile.optionBtnTitle,
      optionBtnClick: tile.optionBtnClick
      // alertheading={"Abel’s Coffee"}
      ,
      alertMessageType: tile.alertMessageType,
      alertText: tile.alertText,
      Description: tile.Description,
      alertImageLeft: tile.alertImageLeft
      // alertImageRight={ArrowRight.default}
    });
  })));
};
var _default = SystemDetailTile;
exports.default = _default;